module.exports = {"id":"223285","name":"Mohamed Larbi","rating":"71","photo":"./data/images/photos/3/223285.png","club":{"name":"Tours FC","logo":"./data/images/clubs/ToursFC.png"},"positions":["MOC","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MohamedLarbi0.json
// module id = 3063
// module chunks = 0